import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore,
} from "react-toasts";
import ForgotPassword from "./Auth/ForgotPassword";
import Login from "./Auth/Login";
import Logout from "./Auth/Logout";
import Attrition from "./Pages/Attrition";
import BomChecklist from "./Pages/BomChecklist";
import BomPage from "./Pages/BomPage";
import History from "./Pages/History";
import Home from "./Pages/Home";
import Parts from "./Pages/Parts";
import Profile from "./Pages/Profile";
import SystemSetting from "./Pages/SystemSetting";
import User from "./Pages/User";
import Vendor from "./Pages/Vendor";
import { PartRefreshQueueProvider } from "../context/PartRefreshQueueContext";
import PartRefreshQueueDock from "./PartRefreshQueue/PartRefreshQueueDock";

const App = ({ user }) => (
  <React.Fragment>
    <ToastsContainer
      position={ToastsContainerPosition.TOP_RIGHT}
      store={ToastsStore}
    />
    <PartRefreshQueueProvider token={user.token}>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/logout" component={Logout} />
        <Route exact path="/forgotpassword" component={ForgotPassword} />
        {user.token && <Route exact path="/" component={Home} />}
        {user.token && <Route exact path="/user" component={User} />}
        {user.token && <Route exact path="/bomChecklist" component={BomChecklist} />}
        {user.token && <Route exact path="/vendor" component={Vendor} />}
        {user.token && <Route exact path="/attritions" component={Attrition} />}
        {user.token && <Route exact path="/parts" component={Parts} />}
        {user.token && (
          <Redirect exact from="/packageLeadTypes" to="/attritions" />
        )}
        {user.token && <Route exact path="/profile" component={Profile} />}
        {user.token && <Route exact path="/history" component={History} />}
        {user.token && <Route exact path="/history/:id" component={BomPage} />}
        {user.token && (
          <Route exact path="/systemSettings" component={SystemSetting} />
        )}
        <Redirect to="/login" />
      </Switch>
      {user.token ? <PartRefreshQueueDock /> : null}
    </PartRefreshQueueProvider>
  </React.Fragment>
  // </Suspense>
);

App.propTypes = {
  user: PropTypes.shape({}).isRequired,
};

export default withRouter(connect((state) => ({ user: state.user }))(App));
